import { lazy, Suspense } from 'react'
import { useFeedConfig } from '../../contexts/feedConfigContext'
import type { LegOddsData } from '../../stores/oddsStore'
import type { Selection } from '../../types/feedContract'

const LiveProgress = lazy(() => import('./LiveProgress').catch(() => ({ default: (): null => null })))

/** Disabled organizations neither import the chunk nor make live requests. */
export function LiveLegProgress({ selection, odds }: { selection: Selection; odds?: LegOddsData }) {
  const { liveStatsEnabled, organization } = useFeedConfig()
  if (!liveStatsEnabled || organization.trim().toLowerCase() === 'ballys' || !odds?.outcome?.isLive || odds.isClosed) return null
  return <Suspense fallback={null}><LiveProgress selection={selection} odds={odds} /></Suspense>
}
